// CSS-only hover card. Uses a named group so it doesn't react to other
// `group` hovers on the page (e.g. the progress bar's breakdown card).
const placements = {
  top: "bottom-full mb-2",
  bottom: "top-full mt-2",
}

const aligns = {
  left: "left-0",
  right: "right-0",
}

const StatusHint = ({ text, placement = "top", align = "left", children }) => {
  if (!text) return children

  return (
    <span className="group/hint relative inline-flex">
      {children}
      <span
        className={`pointer-events-none absolute z-20 hidden w-64 whitespace-normal rounded-lg border border-gray-200 bg-white px-3 py-2 text-left text-xs font-normal leading-snug text-gray-700 shadow-md group-hover/hint:block ${placements[placement]} ${aligns[align]}`}
        role="tooltip"
      >
        {text}
      </span>
    </span>
  )
}

export default StatusHint
